<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.settings.orders_and_invoices` | trans }}
    </h1>
    <a slot="buttons" :href="routes.settings" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      {{ `app.back` | trans }}
    </a>
    <v-alert type="warning" :value="invoice_missing">
      {{ `app.settings.invoice_missing`|trans }}
    </v-alert>
    <v-alert type="success"
             :value="payment_success"
             v-html="trans('app.settings.orders_and_invoices.orders.payment_success')">
    </v-alert>
    <v-alert type="error"
             :value="payment_failure"
             v-html="trans('app.settings.orders_and_invoices.orders.payment_failure')">
    </v-alert>
    <v-app id="vuetify-app">
      <v-container fluid grid-list-md>
        <v-layout justify-space-between>
          <v-flex xs3 sm3 md3 d-flex>
            <h4>{{ `app.settings.orders`|trans }}</h4>
          </v-flex>
          <v-flex xs3 sm3 md3 d-flex>
            <v-text-field
                v-model="filters.query"
                append-icon="search"
                :label="trans('app.search.search')"
                single-line
                hide-details
                solo
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <resource-table ref="table" :endpoint="routes.orders" :headers="headers" :filters="filters">
        <template #content="{item}">
          <tr>
            <td>
              {{ item.id }}
            </td>
            <td>
              {{ item.created_at }}
            </td>
            <td>
              {{ item.subscriptionName }}
            </td>
            <td>
              {{ item.status === 'closed' ? item.start_date : '-' }}
            </td>
            <td>
              {{ item.status === 'closed' ?  item.end_date : '-' }}
            </td>
            <td>
              {{ item.status === 'closed' ? item.duration : '-' }}
            </td>
            <td>
              {{ item.with_discount | money }}
            </td>
            <td>
              {{ `page.orders.` + item.status | trans }}
            </td>
            <td>
              <v-tooltip top v-if="item.status === 'open'">
                <template #activator="{ on }">
                  <v-btn
                      v-on="on"
                      flat
                      icon
                      color="orange"
                      class="mr-0 ml-0"
                      :href="'/subscription/order/' + item.uuid"
                  >
                    <v-icon small>payment</v-icon>
                  </v-btn>
                </template>
                <span>{{ 'app.settings.orders_and_invoices.orders.pay' | trans }}</span>
              </v-tooltip>
              <v-tooltip top v-if="item.status === 'closed'">
                <template #activator="{ on }">
                  <v-btn
                      v-on="on"
                      flat
                      icon
                      color="light-blue"
                      class="mr-0 ml-0"
                      :href="'/subscription/order/' + item.uuid"
                  >
                    <v-icon small>launch</v-icon>
                  </v-btn>
                </template>
                <span>{{ 'app.settings.orders_and_invoices.orders.details' | trans }}</span>
              </v-tooltip>
              <v-tooltip top v-if="item.status === 'closed'">
                <template #activator="{ on }">
                  <v-btn
                      v-on="on"
                      flat
                      icon
                      color="green"
                      class="mr-0 ml-0"
                      :disabled="loading"
                      @click="downloadInvoice(item.uuid)"
                  >
                    <v-icon small>description</v-icon>
                  </v-btn>
                </template>
                <span>{{ 'app.settings.orders_and_invoices.orders.invoice' | trans }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </resource-table>
      <v-divider></v-divider>
      <v-container fluid>
        <h4>{{ 'app.invoice.data' | trans }}</h4>
        <order-invoice-form></order-invoice-form>
      </v-container>
    </v-app>
  </base-layout>
</template>

<script>
import {trans} from '../../app';

export default {
  props: {
    routes: Object,
    invoice_missing: Boolean,
    payment_failure: Boolean,
    payment_success: Boolean,
  },
  data: () => ({
    status: '',
    headers: [
      {
        text: trans('app.settings.orders_and_invoices.orders.id'), align: 'left', value: 'orders.id', sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.created_at'),
        align: 'left',
        value: 'orders.created_at',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.subscription'),
        align: 'left',
        value: 'subscription_types.name',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.start_date'),
        align: 'left',
        value: 'orders.start_date',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.end_date'),
        align: 'left',
        value: 'orders.end_date',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.duration'),
        align: 'left',
        value: 'orders.end_date',
        sortable: false,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.amount'),
        align: 'left',
        value: 'orders.amount',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.status'),
        align: 'left',
        value: 'orders.status',
        sortable: true,
      },
      {
        text: trans('app.settings.orders_and_invoices.orders.invoice'), align: 'center', value: '', sortable: false,
      },
    ],
    filters: {
      query: null,
    },
    loading: false,
  }),
  created() {
    setTimeout(()=> {
      window.Echo.private('invoice-pdf-created-' + window.user.id)
          .listen('InvoicePdfCreatedEvent', (e) => {
            axios.get(e.url, {
              responseType: 'arraybuffer',
            }).then(({data}) => {
              const downloadUrl = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', e.fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
              this.loading = false;
            }).catch((error) => {
              this.loading = false;
              this.sentryCaptureException(error);
            });
          });
    }, 1000);
  },
  methods: {
    downloadInvoice(uuid) {
      axios.post('/profile/orders/' + uuid + '/invoice')
          .then(() => {
            this.loading = true;
          })
          .catch(error => {
            this.loading = false;
            this.sentryCaptureException(error);
          })
    }
  }
}
</script>
<style scoped>
.v-datatable tr td:last-child {
  display: flex;
  justify-content: center;
}
</style>
